import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

export type CreateUserData = {
    firstName: string;
    lastname: string;
    email: string;
    phoneNumber: string;
    preferredOrderIdSuffix: string;
    groupIds: string[];
}

export const useCreateUserRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (data: CreateUserData) => {
            const token = await getJwtToken();

            const response = await fetch(`${BACKEND_URL}/users`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Failed to create user');
            }

            return await response.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
        },
    });

    return {
        createUser: mutation.mutateAsync,
        ...mutation,
    };
};
